import get from "lodash/get";
import {
    reprocessOdooInvoiceClientLoading,
    reprocessOdooInvoiceClientReject,
    reprocessOdooInvoiceClientRequest,
    reprocessOdooInvoiceClientSuccess,
    reprocessOdooInvoiceClientReset,
} from "../../actions/invoiceClient/reprocessOdoo";

export const reprocessOdooInvoiceClient = (InvoiceId) => async (dispatch, getState) => {
    dispatch(reprocessOdooInvoiceClientLoading());
    try {
        const { data } = await reprocessOdooInvoiceClientRequest({ InvoiceId }, getState);
        dispatch(reprocessOdooInvoiceClientSuccess(data));
    } catch (error) {
        dispatch(reprocessOdooInvoiceClientReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(reprocessOdooInvoiceClientReset()); }, 3000);
    }
    return Promise.resolve();
};
